import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import actionTypes from "./actionTypes";

const initialState = {
  alerted: [],
  isLoading: false,
  loading: {},
  notification: null,
  settings: {},
};

export default persistReducer(
  {
    storage,
    key: "user",
    whitelist: ["alerted", "settings"],
  },
  (prevState = initialState, action) => {
    const state = {
      ...prevState,
    };

    switch (action.type) {
      case actionTypes.STORE_ALERTED:
        state.alerted = [...state.alerted, action.payload];
        return state;

      case actionTypes.STORE_LOADING:
        const { type, loading } = action.payload;
        state.loading = {
          ...state.loading,
        };
        if (loading) {
          state.loading[type] = true;
        } else {
          delete state.loading[type];
        }
        state.isLoading = !!Object.keys(state.loading).length;
        return state;

      case actionTypes.STORE_NOTIFICATION:
        state.notification = action.payload && {
          ...action.payload,
          id: `${performance.now()}-${Math.random()}`,
        };
        return state;

      case actionTypes.STORE_SETTINGS:
        state.settings = {
          ...state.settings,
          ...action.payload,
        };
        return state;

      default:
        return state;
    }
  }
);
